import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(callback: () => void) {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}

/**
 * En servidor / prerender asumimos "sin movimiento reducido" para que el
 * snapshot coincida con el valor por defecto del cliente y no haya mismatch de
 * hidratación. El CSS de @media ya cubre el caso real de forma independiente.
 */
function getServerSnapshot() {
  return false;
}

/**
 * Lee la preferencia del sistema y REACCIONA a sus cambios en caliente — el
 * usuario puede activar "reducir movimiento" con la página ya abierta.
 *
 * El CSS de src/styles/index.css ya neutraliza animaciones vía @media; este
 * hook existe para lo que el CSS no puede hacer: evitar que el
 * IntersectionObserver llegue siquiera a poner un elemento en opacity: 0.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
